import { ZONES, SITE } from '../lib/site';
import { MapPin } from 'lucide-react';

const ZonesSection = () => {
  return (
    <section id="zonas" className="py-24 md:py-28 max-w-[1400px] mx-auto px-6">
      <div className="grid lg:grid-cols-[1fr_1.4fr] gap-12 lg:gap-20 items-start">
        <div className="reveal lg:sticky lg:top-28">
          <p className="label">Dónde trabajamos</p>
          <h2 className="font-display font-black uppercase tracking-[-0.02em] text-section-title mt-5">
            Toda la Costa del Sol, <em className="font-serifit normal-case font-normal text-clay">con equipo propio</em>
          </h2>
          <p className="mt-6 text-ink-soft leading-relaxed max-w-md">
            Desde Málaga capital hasta Nerja, y de Torremolinos a Estepona:
            atendemos tu reforma u obra sin desplazamientos extra ni subcontratación.
            Equipos de la provincia, para la provincia.
          </p>
          <a href={`tel:${SITE.phone}`} className="btn mt-8 border border-ink text-ink">
            <MapPin size={16} />
            ¿Tu zona no está? Llámanos
          </a>
        </div>

        <ul className="flex flex-wrap gap-3 reveal" aria-label="Zonas de servicio">
          {ZONES.map((zone) => (
            <li key={zone.slug}>
              <span className="zone-chip">
                {zone.name}
                <span className="w-1.5 h-1.5 rounded-full bg-clay/60" aria-hidden="true" />
              </span>
            </li>
          ))}
          <li>
            <span className="zone-chip border-dashed text-ink-faint">+ resto de la provincia</span>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default ZonesSection;
